/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Chat_Activity_DescInputs */



/**
* | output |
* | --- |
* | "A chat message was sent via the LLM gateway." |
*
* @param {Audit_Details_Chat_Activity_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_chat_activity_desc = /** @type {((inputs?: Audit_Details_Chat_Activity_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Chat_Activity_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Chat-Nachricht wurde über das LLM-Gateway gesendet.")
	return /** @type {LocalizedString} */ ("A chat message was sent via the LLM gateway.")
});